import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/12_card_back_monarch_dog/12_card_back_monarch_dog"
 * Contains 1 texture(s)
 */
export class CardsBacks12CardBackMonarchDogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/12_card_back_monarch_dog/12_card_back_monarch_dog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '12_monarch_dog.png'
    ] as const;
}
